import { useInjectReducer } from "@app/store";
import Button from "@components/Button";
import DeleteDialog from "@components/DeleteDialog";
import { FilterInput } from "@components/FilterInputs";
import PageContent from "@components/PageContent";
import PageFilter from "@components/PageFilter";
import PageHeader from "@components/PageHeader";
import Table from "@components/Table";
import TableMenu from "@components/Table/TableMenu";
import {
  useDeleteFieldDataMutation,
  useLoadAllFieldDataMutation,
} from "@features/admin/mainFieldManage/mainFieldManageApiSlice";
import { makeSelectAll } from "@features/admin/mainFieldManage/mainFieldManageSelector";
import mainFieldManageSlice from "@features/admin/mainFieldManage/mainFieldManageSlice";
import { enqueueSnackbar, makeSelectAccess } from "@features/auth/authSlice";
import { APP_NAME } from "@utils/constants";
import { checkAccess } from "@utils/helpers";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { RiAddLine, RiSearchLine } from "react-icons/ri";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const MainFieldManage = () => {
  useInjectReducer("mainFieldManage", mainFieldManageSlice);
  const navigate = useNavigate();
  const access = useSelector(makeSelectAccess);
  const all = useSelector(makeSelectAll);
  const dispatch = useDispatch();

  //rtk
  const [
    loadAll,
    { data: mainFieldData, isLoading: loading, isSuccess: success },
  ] = useLoadAllFieldDataMutation();

  const [deleteOne, { isLoading: deleteLoading }] =
    useDeleteFieldDataMutation();

  const [open, setOpen] = useState(false);
  const [deletedId, setDeletedId] = useState("");

  useEffect(() => {
    loadAll();
  }, []);

  const handleAddEdit = (id) => {
    if (id) {
      navigate(`/admin/scheme-manage/main-field/edit/${id}`);
    } else {
      navigate(`/admin/scheme-manage/main-field/add`);
    }
  };

  const handleOpen = (id) => {
    setOpen(true);
    setDeletedId(id);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    deleteOne(deletedId)
      .unwrap()
      .then((res) => {
        if (res?.success) {
          dispatch(
            enqueueSnackbar({
              message: res?.msg ?? "Field Deleted.",
              options: { variant: "success" },
            })
          );
          setOpen(false);
          loadAll();
        }
      })
      .catch((err) => {
        dispatch(
          enqueueSnackbar({
            message: err?.data?.msg ?? "Field Delete Failed.",
            options: {},
          })
        );
      });
  };

  const tableData = success
    ? all?.data.map(({ _id, name, is_active }) => [
        name ? name : "-",
        is_active ? (
          <span className='text-green-500'> Active </span>
        ) : (
          <span className='text-red-500'> In Active</span>
        ),
        <>
          <TableMenu
            items={[
              {
                hasAccess: true,
                jsx: <div>Edit</div>,
                onClick: () => handleAddEdit(_id),
              },
              {
                hasAccess: true,
                jsx: <div>Delete</div>,
                onClick: () => handleOpen(_id),
              },
            ]}
          />
        </>,
      ])
    : [];

  return (
    <>
      <DeleteDialog open={open} doClose={handleClose} doDelete={handleDelete} />
      <Helmet>
        <title>{`Field Name Manage |  ${APP_NAME}`}</title>
      </Helmet>

      <div className='flex justify-between my-3'>
        <PageHeader title={`Field Name Manage`} className='mb-0' />
        {checkAccess("/admin/scheme-manage/main-field/add", access, true) && (
          <Button
            leftSection={<RiAddLine />}
            onClick={() => handleAddEdit(null)}
          >
            Add New Field
          </Button>
        )}
      </div>
      <PageFilter>
        <div className='flex justify-between items-center'>
          <div className='grid grid-cols-3 gap-2 w-[600px]'>
            <FilterInput
              label='Search Field By Name'
              //   value={query?.find_name || ""}
              //   onChange={handleChangeQuery("find_name")}
              //   onKeyPress={handleKeyPress}
              id='find_name'
              name='find_name'
            />
            <Button
              isFilter
              leftSection={<RiSearchLine />}
              //   onClick={handleSearch}
            >
              Search
            </Button>
          </div>
        </div>
      </PageFilter>
      <PageContent>
        <Table
          tableHead={[
            "Field Name",
            // "Field Code",
            // "Description",
            "Status",
            "Action",
          ]}
          tableData={tableData}
          emptyDataMsg='No Field Found'
          isSN
          ispublic
        />
      </PageContent>
    </>
  );
};

export default MainFieldManage;
